import React, { Component } from 'react';
import Styles from './style.css';
import { langRegister } from "../../services/langRegister";
import cx from "classnames";
import { BeatLoader } from "react-spinners";
import {dataRegister} from "../../services/dataRegister";

class FeedProperty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image: '',
            id: null
        };
    };

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextState) {

    }

    componentWillMount() {
        this.parsers.data(this.props.data);
    }


    functions = {
        link: () => {
                window.open("https://lp." + dataRegister.domain + "/" + this.state.id, '_blank');
        }
    };


    parsers = {
        data: (data) => {
            try {
                this.state.id = data['landingpage-id'];
            } catch (e) { }
            try {
                this.state.image = data.image.instagram.feed;
            } catch (e) { }


            this.setState({
                image: this.state.image,
            });

        }
    };


    render() {
        return (
            <div onClick={() => this.functions.link()} className={Styles.container}>
                <div className={Styles.containerImage}>
                    <div className={Styles.containerImageLoader}>
                        <BeatLoader size={15} color={'var(--first-color)'} loading={true} />
                    </div>
                    {
                        <div style={{backgroundImage: 'url(' + this.state.image + ')'}} className={Styles.containerImageItem}/>
                    }
                </div>
            </div>
        );
    }
}

export default FeedProperty;


// WEBPACK FOOTER //
// ./src/components/feed-property/component.js